import React from 'react';

const ClientMenuNav = props => {
  const { subject: client, className, extras = {}, isMobile } = props;
  const { menu_selections = [] } =
    'menu_selections' in extras && extras.menu_selections.length > 0
      ? extras
      : client;

  if (menu_selections.length === 0) return '';

  // mobile version
  if (isMobile) {
    const total = menu_selections.reduce(
      (accum, selection) => selection.quantity + accum,
      0
    );
    return (
      <div className={className}>
        <div className="on-boarding-nav-item__menu--mobile">{total}</div>
      </div>
    );
  }

  // desktop version
  const menu = menu_selections
    .filter(selection => selection.quantity > 0)
    .map(selection => (
      <div key={selection.dish_id} className="on-boarding-nav-item__menu--row">
        <span className="on-boarding-nav-item__menu--count">
          {selection.quantity}
        </span>
        <p className="on-boarding-nav-item__menu--name">
          {selection.dish.name}
        </p>
      </div>
    ));

  const classes = [className, 'on-boarding-nav-item__menu'];
  return <div className={classes.join(' ')}>{menu}</div>;
};

export default ClientMenuNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientMenuNav.js